import React, { useEffect, useState } from "react";
import {
  OnboardConstants,
  StaffListConstants,
} from "../../constants/constants";
import BriefcaseIconWhiteBG from "../../assets/images/BriefcaseIconWhiteBG";
import BankIcon from "../../assets/images/BankIcon";
import ProfileIcon2 from "../../assets/images/ProfileIcon2";
import BriefcaseIcon from "../../assets/images/BriefcaseIcon";
import RoleIcon from "../../assets/images/RoleIcon";
import BankIcon2 from "../../assets/images/BankIcon2";
import ProfileIconWhiteBG from "../../assets/images/ProfileIconWhiteBG";
import { UserProfileDetail } from "./UserProfileDetail";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store/store";
import {
  fetchUserDetailsAsync,
} from "../../store/thunks/userThunk";
import { StaffListTitle } from "./StaffDetailTitle";
import { useParams } from "react-router-dom";
import {
  resetResendConsentSMSStatus,
  resetUpdateUserStatus,
  STATUS,
} from "../../store/slices/userDetailslice";
import Loader from "./styles/Loader";
import LoaderPopupModel from "./LoaderPopup";

import PopupModalWithCancelButton from "./PopupModalWithCancelButton";
import WarningIcon from "../../assets/images/WarningIcon";
import RoleIcon2 from "../../assets/images/RoleIcon2";
import StaffValidationIcon from "../../assets/images/StaffValidationIcon";
import StaffValidationIcon2 from "../../assets/images/StaffValidationIcon2";
import {
  PopupMessage,
  SideMenuStaffVerification,
} from "./SideMenuStaffVerification";
import { DynamicUserDetail } from "./DynamicUserDeatil";
import {
  fetchDynamicUserDetailsAsync,
  updateDynamicUserDetailsAsync,
} from "../../store/thunks/userOnboardThunk";
import PersonalInformationDynamic from "./PersonalInformationDynamic";
import { StaffDetailAndroid } from "../pages/StaffDetail/StaffDetailAndorid";
import Popup from "./PopupComponent";


export interface Tab {
  label: string;
  icon: React.ElementType;
  activeIcon: React.ElementType;
}
export const getActionTabs = (ekycEnabled: boolean) => {
  if (ekycEnabled) {
    return tabs;
  } else {
    return tabs.filter(
      (tab) => tab.label !== StaffListConstants.staffValidation
    );
  }
};

const tabs: Tab[] = [
  {
    label: StaffListConstants.PersonalInformation,
    icon: ProfileIconWhiteBG,
    activeIcon: ProfileIcon2,
  },
  {
    label: StaffListConstants.educationalDetails,
    icon: BriefcaseIconWhiteBG,
    activeIcon: BriefcaseIcon,
  },
  {
    label: StaffListConstants.RolesAndPermissions,
    icon: RoleIcon,
    activeIcon: RoleIcon2,
  },
  {
    label: StaffListConstants.BankAccountDetails,
    icon: BankIcon,
    activeIcon: BankIcon2,
  },
  {
    label: StaffListConstants.staffValidation,
    icon: StaffValidationIcon,
    activeIcon: StaffValidationIcon2,
  },
];

export const StaffDetailsComponent: React.FC = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [editMode, setEditMode] = useState(false);
  const dispatch = useDispatch<AppDispatch>();
  const userDetails = useSelector((state: RootState) => state.userDetails.user);
  const [userInfo, setUserInfo] = useState(userDetails);
  const { userid } = useParams<{ userid: string }>();
  const [showPopUp, setShowPopUp] = useState(false);
  const [showBankDetailRequiredPopUp, setshowBankDetailRequiredPopUp] =
    useState(false);
  const [isBankDetailRequired, setIsBankDetailRequired] = useState(false);
  const [popupMessage, setpopupMessage] = useState("");
  const [showApplicationErrorMessage, setShowApplicationErrorMessage] =
    useState(false);
  const verifyPhoneNumberAsyncStatus = useSelector(
    (state: RootState) => state.userDetails.verifyPrimaryPhonenumberAPIStatus
  );
  const phoneNumberStatus = useSelector(
    (state: RootState) => state.userDetails.phoneNumberStatus
  );
  const isUserDetailLoading = useSelector(
    (state: RootState) => state.userDetails.loading
  );
  const [isPhoneNumberExists, setPhoneNumberStatus] = useState<boolean | null>(
    false
  );

  const [consentForm, setConsentForm] = useState<File | null>(null);
  const [passbookForm, setPassBookForm] = useState<File | null>(null);
  const [editButtonName, setEditButtonName] = useState(
    "Edit Personal Information"
  );

  const applicationDetails = useSelector(
    (state: RootState) => state.userDetails.applicationDetails
  );
  const [userApplicationsDetails, setUserApplicationsDetails] =
    useState(applicationDetails);
  const [isUserEditLoading, setUserEditLoading] = useState(false);

  const updateUserLoading = useSelector(
    (state: RootState) => state.userDetails.updateUserLoading
  );
  const activeTabForEditFlow = useSelector(
    (state: RootState) => state.roleDetails.activeTabForEditFlow
  );
  const resendConsentSMSErrorMsg = useSelector(
    (state: RootState) => state.userDetails.resendConsentnErrorMsg
  );
  const resendConsentSMSLoading = useSelector(
    (state: RootState) => state.userDetails.resendConsentMessageStatus
  );
  const resendConsentSMS = useSelector(
    (state: RootState) => state.userDetails.resendConsentMessage
  );
  const userDetailJsonObj = useSelector(
    (state: RootState) => state.userOnboardingJsonDetails?.userDetailResponse
  );
  const userDetailUpdateStatus = useSelector(
    (state: RootState) =>
      state.userOnboardingJsonDetails?.userDetailResponseStatus
  );
  const [popUpMsg, setPopUpMsg] = useState<PopupMessage>({
    title: "",
    message: "",
  });

  const [editPayloadJson, setEditPayloadjson] = useState<any>(null);
  const [isCancelButtonClicked, setIsCancelButtonClicked] = useState(false);
  const [isSucceeded, setIsSucceeded] = useState(false);
  useEffect(() => {
    // setEditPayloadjson(JSON.parse(JSON.stringify(ressponse)));
    setEditPayloadjson(JSON.parse(JSON.stringify(userDetailJsonObj)));
  }, [userDetailJsonObj, userDetailUpdateStatus, isCancelButtonClicked]);

  useEffect(() => {
    dispatch(fetchDynamicUserDetailsAsync(userid ?? "0"));
  }, [dispatch, userDetailUpdateStatus, isCancelButtonClicked]);

  useEffect(() => {
    // setUserInfo(userDetails);
    if (updateUserLoading === STATUS.SUCCESS) {
      setPopUpMsg({
        title: StaffListConstants.editFlowSucessMsg,
        message: `${StaffListConstants.UserApprovedDescription} `,
      });
      setShowPopUp(true);
      setIsSucceeded(true);
    }
    if (updateUserLoading === STATUS.FAILED) {
      setPopUpMsg({
        title: errorUserEditFLowMsg ?? "Failed to update the details",
        message: StaffListConstants.UserApprovedDescription,
      });
      setShowPopUp(true);
      setIsSucceeded(false);
    }
  }, [userDetails, updateUserLoading]);

  useEffect(() => {
    setUserApplicationsDetails(applicationDetails);
  }, [applicationDetails]);

  useEffect(() => {
    if (
      activeTab === 2 &&
      JSON.stringify(userApplicationsDetails) !==
        JSON.stringify(applicationDetails)
    ) {
      handleSaveButton();
    }
  }, [userApplicationsDetails]);

  useEffect(() => {
    handleDisplayOfUserEditLoader();
  }, [updateUserLoading, resendConsentSMSLoading]);

  useEffect(() => {
    if (resendConsentSMSLoading === STATUS.SUCCESS) {
      if (resendConsentSMS?.smsSent === true) {
        setPopUpMsg({
          title: OnboardConstants.resendConsentSMS,
          message: `${OnboardConstants.resendSMSSuccessMessage}`,
        });
        setShowPopUp(true);
        setIsSucceeded(true);
      } else {
        setPopUpMsg({
          title: resendConsentSMS?.message ?? "Failed to send consent SMS",
          message: "",
        });
        setShowPopUp(true);
        setIsSucceeded(false);
      }
    }
    if (resendConsentSMSLoading === STATUS.FAILED) {
      setPopUpMsg({
        title: StaffListConstants.APIErrorMessage,
        message: resendConsentSMSErrorMsg ?? "Failed to send consent SMS",
      });
      setIsSucceeded(false);
      setShowPopUp(true);
    }
  }, [resendConsentSMSLoading, resendConsentSMS]);

  useEffect(() => {
    if (activeTab == 4) {
      dispatch(fetchUserDetailsAsync(editPayloadJson?.userId ?? ""));
    }
  }, [activeTab]);
  useEffect(() => {
    if (activeTabForEditFlow === 2) {
      setActiveTab(2);
    }
  }, [activeTabForEditFlow]);
  useEffect(() => {
    if (verifyPhoneNumberAsyncStatus === STATUS.SUCCESS) {
      if (phoneNumberStatus?.exists === true) {
        setPhoneNumberStatus(true);
      } else {
        setPhoneNumberStatus(false);
      }
    }
  }, [verifyPhoneNumberAsyncStatus]);
  useEffect(() => {
    if (
      activeTab === 2 &&
      JSON.stringify(userDetails) !== JSON.stringify(userInfo)
    ) {
      handleSaveButton();
    }
  }, [userInfo?.baseRoles, userApplicationsDetails]);

  const handleDisplayOfUserEditLoader = () => {
    if (
      updateUserLoading == STATUS.LOADING ||
      resendConsentSMSLoading == STATUS.LOADING
    )
      setUserEditLoading(true);
    else setUserEditLoading(false);
  };

  const handleTabClick = (index: number) => {
    if (index === 0) {
      setEditButtonName("Edit Personal Information");
    } else if (index === 1) {
      setEditButtonName("Edit Educational Details");
    } else if (index === 3) {
      setEditButtonName("Edit Bank account details");
    }
    setUserInfo(userDetails);
    setActiveTab(index);
    setEditMode(false);
    setIsBankDetailRequired(false);
    dispatch(resetResendConsentSMSStatus());
  };
  const handleEditButton = () => {
    setEditMode(true);
  };

  useEffect(() => {
    if (showPopUp === false) {
      dispatch(resetUpdateUserStatus());
      setPopUpMsg({
        title: "",
        message: "",
      });
      setIsSucceeded(false);
      dispatch(resetResendConsentSMSStatus());
    }
  }, [showPopUp]);
  const closeModal = () => {
    setShowPopUp(false);
    dispatch(resetUpdateUserStatus());
    dispatch(resetResendConsentSMSStatus());
    setshowBankDetailRequiredPopUp(false);
    setIsBankDetailRequired(false);
    forceRerender();
  };

  const handleCancelButton = () => {
    setIsCancelButtonClicked(!isCancelButtonClicked);
    setUserInfo(userDetails);
    setEditMode(false);
    setIsBankDetailRequired(false);
  };
  function hasCountryCode(phoneNumber: string): boolean {
    // Regular expression to match country code at the beginning of the phoneNumber
    const countryCodeRegex = /^\+91/;

    return countryCodeRegex.test(phoneNumber);
  }

  const [showSaveRolesButton, setShowSaveRolesButton] = useState(false);
  const [showSaveWorkButton, setShowSaveWorkButton] = useState(false);
  const [showSaveEducationButton, setShowSaveEducationButton] = useState(false);
  const [editModeForEducationalDetails, setEditModeForEducationalDetails] =
    useState(false);
  const [editModeForWorkDetails, setEditModeForWorkDetails] = useState(false);
  type ValidationRule = {
    value?: string;
    minLength?: number;
    maxLength?: number;
    errorMessage?: string;
  };
  
  const [errors, setErrors] = useState<Record<string, string>>({});
  const validateValue = (
    value: string,
    rules: ValidationRule[]
  ): string | null => {
    for (const rule of rules) {
      if (rule.value && !new RegExp(rule.value).test(value)) {
        console.log(
          "rule.errorMessage",
          rule.errorMessage,
          !new RegExp(rule.value).test(value)
        );
        return rule.errorMessage || "Invalid format";
      }
      if (rule.minLength !== undefined && value.length < rule.minLength) {
        return rule.errorMessage || `Minimum length is ${rule.minLength}`;
      }
      if (rule.maxLength !== undefined && value.length > rule.maxLength) {
        return rule.errorMessage || `Maximum length is ${rule.maxLength}`;
      }
    }
    return null; // No errors
  };

  const validateFormDataForMultiple = (
    jsonObject: any[],
    payload: any[],
    payloadName: any,
    isBranchesManditory?:any,
  ) => {
    const errors: Record<string, string> = {};
    jsonObject.forEach((segment) => {
      const payloadSegment = payload.find(
        (p) => p.subSegmentId === segment?.subSegmentId
      );
      if (payloadName === "Roles" ||  payloadName === "Educational Information" ||
      payloadName === "Work Experience" || payloadName === "branches" ) {
        let requiredFields: string[] = [];
        if(payloadName === "Roles" ) {
       requiredFields =  isBranchesManditory ?  ["deptId", "groupId", "roleId","specializationIds"] : ["deptId", "groupId", "roleId"];

        }
       else if( payloadName === "branches" && isBranchesManditory){
          requiredFields = ["branches"]
        }
        else {
          requiredFields = segment?.attributes
            .filter((attr: { isRequired: boolean }) => attr.isRequired)
            .map((attr: { name: string }) => attr.name);
        }

        if (payloadSegment && Array.isArray(payloadSegment.attributes)) {
          const attributeMap = payloadSegment.attributes.reduce(
            (acc: any, attr: any) => {
              acc[attr.name || attr.att] = attr.value;
              return acc;
            },
            {}
          );
          requiredFields.forEach((field) => {
            const value = attributeMap[field];
            // Special handling for branches array
            if (field === "branches") {
              if (!Array.isArray(value) || value.length === 0) {
                errors[field] = `${field} is required`;
              }
            } else {
              if (value === undefined || value === null || value === "") {
                errors[field] = `${field} is required`;
              }
            }
          });
        }

        if (payloadSegment) {
          segment?.attributes?.forEach(
            (attribute: {
              name: any;
              attributeId: any;
              isRequired: any;
              validationRules: {
                regex?: string | undefined;
                minLength?: number | undefined;
                maxLength?: number | undefined;
                errorMessage?: string | undefined;
              }[];
              label: any;
            }) => {
              const userAttribute = payloadSegment.attributes.find(
                (a: { attributeId: any }) =>
                  a.attributeId === attribute.attributeId
              );
              if (attribute.isRequired && userAttribute) {
                const errorMessage = validateValue(
                  userAttribute.value,
                  attribute.validationRules
                );
                if (errorMessage) {
                  errors[`${attribute.name}`] = errorMessage;
                }
              }
            }
          );
        }
      }
    });
    setErrors(errors);
    return errors;
  };
  const [isErrors, setIsErrors] = useState(true);
  const [isSaveButtonCLicked, setIsSaveButtonClicked] = useState(false);

  const handleSaveButton = async (
    canMultiple?: any,
    selectedIndex?: any,
    payloadName?: any,
    isBranchesManditory?:any,
  ) => {
    setIsApiSucesssful(false);
    if (
      canMultiple &&
      (selectedIndex === "" ||
        selectedIndex === undefined ||
        selectedIndex === null) &&
      (payloadName === "Roles" ||
        payloadName === "Educational Information" ||
        payloadName === "Work Experience" ||
        payloadName === "branches" ||
        payloadName === "Training & Certifications")
    ) {

      ////////////////when adding new education
      const buildPayloadFromTemplate = (subSegments: any[]) => {
        return subSegments.map((segment: any) => ({
          subSegmentId: segment.subSegmentId,
          attributes: segment.attributes.map((attr: any) => ({
            attributeId: attr.attributeId,
            attributeName: attr.name,
            value: attr?.value || "", // or mock values if needed
            name:attr?.name,
          })),
        }));
      };
     
      const formSegments =
        editPayloadJson?.formSegments?.[activeTab]?.subSegments;
      if (formSegments && formSegments.length > 0) {
        const lastSubSegment = formSegments[formSegments.length - 1];
        const errors = validateFormDataForMultiple(
          formSegments, // Full list with rules
          buildPayloadFromTemplate([lastSubSegment]),
          payloadName,
          isBranchesManditory,
          // Needs to be an array
        );
        if (Object.keys(errors).length === 0) {
          setIsErrors(false);
          saveEditUserDetails(true);
          setShowSaveRolesButton(false);
          setShowSaveWorkButton(false);
          setShowSaveEducationButton(false);
          setEditModeForEducationalDetails(false);
          setEditModeForWorkDetails(false);
        } else {
          if (payloadName === "Roles") {
            setShowSaveRolesButton(true);
          } else if (payloadName === "Work Experience") {
            setShowSaveWorkButton(true);
            setEditModeForWorkDetails(true);
          } else if (payloadName === "Educational Information") {
            setEditModeForEducationalDetails(true);
            setShowSaveEducationButton(true);
          }
        }
      }
    } else if (
      canMultiple &&
      (selectedIndex != "" ||
        selectedIndex != undefined ||
        selectedIndex != null) &&
      (payloadName === "Roles" ||
        payloadName === "Educational Information" ||
        payloadName === "Work Experience" ||
        payloadName === "branches" ||
        payloadName === "Training & Certifications")
    ) {
      //////////////////when editing existing education
      const buildPayloadFromTemplate = (subSegments: any[]) => {
        return subSegments.map((segment: any) => ({
          subSegmentId: segment?.subSegmentId,
          attributes: segment?.attributes.map((attr: any) => ({
            attributeId: attr?.attributeId,
            value: attr?.value || "",
            name:attr?.name, // or mock values if needed
          })),
        }));
      };
      const formSegments = editPayloadJson?.formSegments?.[
        activeTab
      ]?.subSegments.filter(
        (item: { name: string }) => item.name === payloadName
      );

      if (formSegments && formSegments.length > 0) {
      
        const lastSubSegment = formSegments[selectedIndex];
        const errors = validateFormDataForMultiple(
          formSegments, // Full list with rules
          buildPayloadFromTemplate([lastSubSegment]),
          payloadName // Needs to be an array
        );
        if (Object.keys(errors).length === 0) {
          setIsErrors(false);
          saveEditUserDetails(true);
          setShowSaveRolesButton(false);
          setShowSaveWorkButton(false);
          setShowSaveEducationButton(false);
          setEditModeForEducationalDetails(false);
          setEditModeForWorkDetails(false);
        } else {
          if (payloadName === "Roles") {
            setShowSaveRolesButton(true);
          } else if (payloadName === "Work Experience") {
            setShowSaveWorkButton(true);
            setEditModeForWorkDetails(true);
          } else if (payloadName === "Educational Information") {
            setEditModeForEducationalDetails(true);
            setShowSaveEducationButton(true);
          }
        }
      }
    } else {
      setIsSaveButtonClicked(true);
    }
  };
  useEffect(() => {
    if (!isErrors && (activeTab === 0 || activeTab === 3)) {
      saveEditUserDetails();
    }
  }, [isErrors]);
const [isApiSucessfull,setIsApiSucesssful]= useState(false);
  const saveEditUserDetails = async (isErrorNotPresent: boolean = false) => {
    const formData = new FormData();
    // if (selectedFile) formData.append("face", selectedFile);
    formData.append(
      "body",
      new Blob([JSON.stringify(editPayloadJson)], {
        type: "application/json",
      })
    );
    if (!isErrors || isErrorNotPresent) {
      setIsApiSucesssful(true);
      await dispatch(
        updateDynamicUserDetailsAsync({ data: formData, userId: userid })
      );
    }
    setEditMode(false);
    setIsErrors(true);
    setShowPopUp(true);
  };

  const errorUserEditFLowMsg = useSelector(
    (state: RootState) => state.userDetails.updateFlowErrorMessage
  );
  const [key, setKey] = useState(0);
  const forceRerender = () => {
    setKey((prevKey) => prevKey + 1); // Toggle boolean to trigger re-render
  };

  const [addMoreRoles, setAddMoreRoles] = useState(false);
  const handleAddMoreRolesButton = () => {
    setAddMoreRoles(true);
  };
  return (
    <>
      <div className="block lg:hidden">
        <StaffDetailAndroid
          isUserDetailLoading={isUserDetailLoading}
          isUserEditLoading={isUserEditLoading}
          editButtonName={editButtonName}
          activeTab={activeTab}
          editMode={editMode}
          handleEditButton={handleEditButton}
          handleSaveButton={handleSaveButton}
          handleCancelButton={handleCancelButton}
          handleAddMoreRolesButton={handleAddMoreRolesButton}
          editPayloadJson={editPayloadJson}
          tabs={tabs}
          handleTabClick={handleTabClick}
          key={key}
          setEditPayloadjson={setEditPayloadjson}
          setEditMode={setEditMode}
          jsonObjData={editPayloadJson}
          setAddMoreRoles={setAddMoreRoles}
          isSaveButtonCLicked={isSaveButtonCLicked}
          setIsErrors={setIsErrors}
          setIsSaveButtonClicked={setIsSaveButtonClicked}
          errors={errors}
          setShowSaveRolesButton={setShowSaveRolesButton}
          setShowSaveWorkButton={setShowSaveWorkButton}
          setShowSaveEducationButton={setShowSaveEducationButton}
          showSaveRolesButton={showSaveRolesButton}
          showSaveWorkButton={showSaveWorkButton}
          showSaveEducationButton={showSaveEducationButton}
          setEditModeForEducationalDetails={setEditModeForEducationalDetails}
          editModeForEducationalDetails={editModeForEducationalDetails}
          setEditModeForWorkDetails={setEditModeForWorkDetails}
          editModeForWorkDetails={editModeForWorkDetails}
          setErrors={setErrors}
          showPopUp={showPopUp}
          closeModal={closeModal}
          updateUserLoading={updateUserLoading}
          resendConsentSMS={resendConsentSMS}
          popUpMsg={popUpMsg}
          isApiSucessfull={isApiSucessfull}
        />
      </div>
      <div className=" hidden lg:block font-poppins">
        <StaffListTitle />
        <div className="bg-whiteColor rounded mt-8 ">
          {isUserDetailLoading ? (
            <div className="h-[600px] items-center justify-center bg-white">
              <Loader />
            </div>
          ) : (
            <>
              {isUserEditLoading && (
                <LoaderPopupModel isOpen={isUserEditLoading} />
              )}
              <UserProfileDetail
                editButtonName={editButtonName}
                activeTab={activeTab}
                isEditMode={editMode}
                handleEditButton={handleEditButton}
                handleSaveButton={handleSaveButton}
                handleCancelButton={handleCancelButton}
                handleAddMoreRolesButton={handleAddMoreRolesButton}
                jsonObjData={editPayloadJson}
                
              />
              <hr className="mx-6 my-4 bg-dividerColor h-[1px] "></hr>

              <div className="flex justify-between pl-8 pr-48 pt-4 ">
                {getActionTabs(editPayloadJson?.isKycEnabled).map(
                  (tab, index) => (
                    <div className="flex flex-col justify-start w-full">
                      <div
                        data-testId={`tab ${index}`}
                        key={index}
                        className={`flex items-center font-nunito cursor-pointer subTitle ${
                          activeTab === index ? "text-primary " : ""
                        }`}
                        style={{
                          fontWeight: activeTab === index ? 700 : 600,
                        }}
                        onClick={() => handleTabClick(index)}
                      >
                        {activeTab === index ? (
                          <tab.activeIcon />
                        ) : (
                          <tab.icon />
                        )}
                        <span className="pl-2">{tab.label}</span>
                      </div>
                      <hr
                        className={`  mt-2 mb-4 mr-3   ${
                          activeTab === index
                            ? "bg-primary h-[4px]"
                            : "bg-dividerColor h-[1px]"
                        }`}
                      ></hr>
                    </div>
                  )
                )}
              </div>
              {activeTab === 4 && <SideMenuStaffVerification />}
              {!editMode ? (
                <div>
                  {/* {ressponse && ( */}
                  {editPayloadJson && (
                    <DynamicUserDetail
                      key={key}
                      jsonObj={editPayloadJson?.formSegments}
                      setEditPayloadjson={setEditPayloadjson}
                      setEditMode={setEditMode}
                      // jsonObj={response?.formSegments }
                      order={activeTab}
                      jsonForEditData={editPayloadJson}
                      // addMoreRoles={addMoreRoles}
                      isEditMode={editMode}
                      handleSaveButton={handleSaveButton}
                      handleCancelButton={handleCancelButton}
                      isSaveButtonCLicked={isSaveButtonCLicked}
                      setIsSaveButtonClicked={setIsSaveButtonClicked}
                      errors={errors}
                      setShowSaveRolesButton={setShowSaveRolesButton}
                      setShowSaveWorkButton={setShowSaveWorkButton}
                      setShowSaveEducationButton={setShowSaveEducationButton}
                      showSaveRolesButton={showSaveRolesButton}
                      showSaveWorkButton={showSaveWorkButton}
                      showSaveEducationButton={showSaveEducationButton}
                      setEditModeForEducationalDetails={
                        setEditModeForEducationalDetails
                      }
                      editModeForEducationalDetails={
                        editModeForEducationalDetails
                      }
                      setEditModeForWorkDetails={setEditModeForWorkDetails}
                      editModeForWorkDetails={editModeForWorkDetails}
                      setErrors={setErrors}
                      isApiSucessfull={isApiSucessfull}
                      // handleEditEducationalInformation={handleEditEducationalInformation}
                    />
                  )}
                </div>
              ) : (
                <div>
                  <PersonalInformationDynamic
                    jsonobj={editPayloadJson?.formSegments}
                    order={activeTab}
                    isEditMode={editMode}
                    setEditPayloadjson={setEditPayloadjson}
                    isSaveButtonCLicked={isSaveButtonCLicked}
                    setIsErrors={setIsErrors}
                    setIsSaveButtonClicked={setIsSaveButtonClicked}
                    setErrors={setErrors}
                    errors={errors}
                  />
                </div>
              )}
            </>
          )}
        </div>
        {showPopUp && (
          <Popup
            popUpTitle={popUpMsg.title}
            popUpMsg={popUpMsg.message}
            buttonText={StaffListConstants.Okay}
            isOpen={showPopUp}
            onClose={closeModal}
            isSucessMessage={isSucceeded}
          />
        )}
        {showBankDetailRequiredPopUp && (
          <PopupModalWithCancelButton
            popUpTitle={StaffListConstants.errorInAddingRole}
            buttonText1={StaffListConstants.addBankDetails}
            buttonText2={StaffListConstants.Cancel}
            icon={<WarningIcon />}
            popUpMsg={popupMessage}
            isOpen={showBankDetailRequiredPopUp}
            onCancel={closeModal}
            onOkay={() => {
              handleTabClick(3);
              setshowBankDetailRequiredPopUp(false);
              setEditMode(true);
              setIsBankDetailRequired(true);
            }}
          />
        )}
      </div>
    </>
  );
};